import React from 'react';
import { BaseCardContent } from '../MessageType';
import { ImageCardView } from './ImageCardView';
import { ProductCardView } from './ProductCardView';
import { OrderCardView } from './OrderCardView';
import { QuickContractCardView } from './QuickContractCardView';
import { ArtifactCardView } from './ArtifactCardView';
import { ContactCardView } from './ContactCardView';

const BRIEF_MAP: Record<string, string> = {
  image: '[图片]',
  camera: '[图片]',
  product: '[技能商品]',
  order: '[订单]',
  quickContract: '[闪电合约]',
  artifact: '[作品集]',
  contact: '[联系方式]',
};

export function getCardBriefInfo(content: BaseCardContent): string {
  return BRIEF_MAP[content.type] || '[卡片消息]';
}

interface CardRenderProps {
  content: BaseCardContent;
  isSelf: boolean;
}

export function renderMessageCard({ content, isSelf }: CardRenderProps): React.ReactNode {
  switch (content.type) {
    case 'image':
    case 'camera':
      return <ImageCardView content={content} />;
    case 'product':
      return <ProductCardView content={content} isSelf={isSelf} />;
    case 'order':
      return <OrderCardView content={content} isSelf={isSelf} />;
    case 'quickContract':
      return <QuickContractCardView content={content} />;
    case 'artifact':
      return <ArtifactCardView content={content} />;
    case 'contact':
      return <ContactCardView content={content} />;
    default:
      return <div className="message-card-fallback">暂不支持的消息类型</div>;
  }
}
